
















































import { CONFIG } from '@/config';
import { Http } from '@/decorators';
import { Size } from '@/enums';
import { http } from '@/services';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { notificationService } from '../../../../services';
import { DAP_ROUTES } from '../../router';
import { AxiosError, AxiosResponse } from 'axios';

@Component
export default class DapProjectChangeFlowDate extends Vue {
  state: any = {
    data: {
      idProject: 0,
      name: '',
      approvalFlowEventDtos: []
    }
  };

  @Prop({ default: false })
  public open: boolean;

  @Prop({ required: true })
  public nameProject: string;

  @Prop({ required: true })
  public id: number;

  public Size = Size;
  public moment = moment;

  @Emit('submit')
  public onSubmit() {
    http.post(`${CONFIG.URL.NEODASH_API}/api/dap/approval/${this.id}/updateFlowEvent`, this.state.data);
    notificationService.sendToast({
      status: 1,
      type: 'success',
      message: 'Datas do fluxo alterados com sucesso!'
    });
  }

  @Emit('cancel')
  public onCancel() {} // tslint:disable-line

  @Watch('nameProject')
  public onNameChange(nameProject: string) {
    this.state.data.name = this.nameProject;
  }

  @Watch('open')
  public getConfiguration() {
    if (this.open) {
      this.state.data.idProject = this.id;
      this.state.data.name = this.nameProject;

      const req = [http.get(`${CONFIG.URL.NEODASH_API}/api/dap/approval/submitted/events/${this.id}`)];

      Promise.all(req)
        .then((req: any) => {
          this.state.data.approvalFlowEventDtos = _(req[0].data[0].approvalFlowEventDtos)
            .orderBy((item: any) => item.order)
            .value();

          this.state.data.dateSubmitForApproval = new Date(this.state.data.approvalFlowEventDtos[0].initialValidity);
        })
        .catch((err: AxiosError) => console.log(err.message));
    }
  }
}
